
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { getOrderDetail, logisticsList, deliver } from '@/api/pcm/order';
import { wait } from '@/utils/wait';
import { Message } from 'element-ui';

export default extend(dialog, {
    namespaced: true,
    state: {
		id: 0,
		detail: {},
		logisticsList: [],
		tableForm: {
			list: []
		},
		form: {}
	},
	getters: {
		totalAmount: state => {
			const shippingFee = Number(state.form.shippingFee);
			const total = Number(state.tableForm.list.reduce((count, v) => {
				return count + v.customInPrice * v.deliverNum;
			}, 0));
			return ((isNaN(shippingFee) ? 0 : shippingFee) + (isNaN(total) ? 0 : total)).toFixed(2);
		}
	},
    actions: {
        async afterOpenDialog({ dispatch, commit, state }, payload) {
			const { id, formRef } = state;
			commit('save', {
				form: {}
			})
            await wait(dispatch, 'pcm.order.ship', async function() {
				const response = await getOrderDetail(id);
				if (response.data) {
					commit('save', {
						detail: response.data.purOrderDetailInfo,
						tableForm: {
							list: response.data.goodsList.map((v) => {
								return {
									...v,
									deliverNum: v.waitDeliveryNum,
									customInPrice: v.inPrice
								}
							})
						}
					})
				}
			})
			await dispatch('getLogisticsList');
		},
		async getLogisticsList({ dispatch, commit, state }) {
			await wait(dispatch, 'pcm.order.getLogisticsList', async function() {
				const response = await logisticsList();
				if (response.data) {
					commit('save', {
						logisticsList: response.data
					})
				}
            })
		},
		async confirm({ dispatch, commit, state, getters }, payload) {
			try {
				const { id, tableForm: { list }, form, logisticsList } = state;
				const { totalAmount } = getters;
				const shipping = logisticsList.find((logistic) => {
					return logistic.shippingId == form.shippingId
				})
				await wait(dispatch, 'pcm.order.shipConfirm', async function() {
					try {
						const response = await deliver(id, {
							deliverPurGoodsList: payload.map((v) => {
								return {
									deliverNum: v.deliverNum,
									purGoodsId: v.purOrderGoodsRecId,
									inPrice: v.customInPrice || 0
								}
							}),
							...form,
							suppCode: form.supp && form.supp.suppCode,
							totalAmount: totalAmount,
							shippingName: shipping && shipping.shippingName
						});
						if (response.data) {
							Message.success('发货成功');
							// 关闭弹窗
							dispatch('closeDialog');
							// 重新获取数据
							dispatch('pcmOrderList/getList', {}, {root: true});
						}
					} catch (error) {
						console.error(error);
					}

				})
			} catch (error) {
				console.error(error)
			}
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/order/ship.js